import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Logo from "@/components/Logo";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const QUESTIONS = [
  { key: "level", title: "Qual é o seu nível atual?", options: ["Nunca joguei", "Iniciante", "Básico", "Intermediário", "Avançado"] },
  { key: "goal", title: "Qual é seu principal objetivo?", options: ["Aprender do zero", "Melhorar minha tática", "Melhorar meu rating", "Jogar torneios", "Criar uma rotina de estudos"] },
  { key: "study_time", title: "Quanto tempo você gostaria de estudar?", options: ["10 minutos por dia", "20 minutos por dia", "30 minutos por dia", "1 hora ou mais"] },
];

export default function Onboarding() {
  const nav = useNavigate();
  const { user, refresh } = useAuth();
  const [step, setStep] = useState(0);
  const [answers, setAnswers] = useState({});
  const [saving, setSaving] = useState(false);

  const pick = (val) => {
    const q = QUESTIONS[step];
    const next = { ...answers, [q.key]: val };
    setAnswers(next);
    if (step < QUESTIONS.length - 1) setStep(step + 1);
  };

  const finish = async () => {
    setSaving(true);
    try { await api.post("/auth/onboarding", answers); await refresh(); nav("/painel"); }
    catch { nav("/painel"); } finally { setSaving(false); }
  };

  const q = QUESTIONS[step];
  const done = QUESTIONS.every((qq) => answers[qq.key]);

  return (
    <div className="min-h-screen bg-chessup-bg flex items-center justify-center p-6 grain">
      <div className="w-full max-w-lg animate-fade-up">
        <div className="text-center mb-8">
          <Logo size={48} className="justify-center" />
          <h1 className="mt-6 font-heading text-2xl text-chessup-text">Bem-vindo à ChessUp Academy{user?.name ? `, ${user.name.split(" ")[0]}` : ""}.</h1>
        </div>
        <div className="flex gap-2 mb-8">
          {QUESTIONS.map((_, i) => (
            <div key={_.key} className={`h-1.5 flex-1 rounded-full ${i <= step ? "bg-chessup-turq" : "bg-chessup-border"}`} />
          ))}
        </div>
        <div className="rounded-2xl border border-chessup-border bg-chessup-card p-6">
          <h2 className="font-heading text-xl text-chessup-text mb-5" data-testid="onboarding-question">{q.title}</h2>
          <div className="space-y-2.5">
            {q.options.map((opt) => (
              <button key={opt} onClick={() => pick(opt)} data-testid={`onboarding-opt-${opt}`}
                className={`w-full text-left rounded-lg border px-4 py-3 text-sm transition-all ${answers[q.key] === opt ? "border-chessup-turq bg-chessup-turq/10 text-chessup-turq" : "border-chessup-border text-chessup-text hover:border-chessup-turq/50"}`}>
                {opt}
              </button>
            ))}
          </div>
          {done && (
            <button onClick={finish} disabled={saving} data-testid="onboarding-finish" className="mt-6 w-full inline-flex items-center justify-center gap-2 rounded-full bg-chessup-gold py-3.5 font-semibold text-chessup-deep hover:bg-chessup-goldlight transition-colors disabled:opacity-60">
              {saving ? "Salvando..." : "COMEÇAR MINHA JORNADA"} <ArrowRight className="h-4 w-4" />
            </button>
          )}
        </div>
        {step > 0 && !done && <button onClick={() => setStep(step - 1)} className="mt-4 text-sm text-chessup-subtext hover:text-chessup-turq">← Voltar</button>}
      </div>
    </div>
  );
}
